var _path, _rect, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73 85H23C22.4477 85 22 84.5523 22 84V12C22 11.4477 22.4477 11 23 11H57V26C57 27.1046 57.8954 28 59 28H74V84C74 84.5523 73.5523 85 73 85ZM77 28V84C77 86.2091 75.2091 88 73 88H23C20.7909 88 19 86.2091 19 84V12C19 9.79086 20.7909 8 23 8H57H58.3431C59.404 8 60.4214 8.42143 61.1716 9.17157L68.5 16.5L75.8284 23.8284C76.5786 24.5786 77 25.596 77 26.6569V28Z",
    fill: "#FA7E23"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 37,
    width: 72,
    height: 32,
    rx: 4,
    fill: "#FA7E23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7734 44.0898V62H26.6309V54.7949H20V62H15.8301V44.0898H20V51.5957H26.6309V44.0898H30.7734Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7441 44.0898V47.2891H41.0137V62H36.8438V47.2891H32.1543V44.0898H45.7441Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4395 44.0898H52.8945L56.9141 56.627H56.9824L61.043 44.0898H66.5254V62H62.3555V57.5566L62.752 49.3809L62.6836 49.3672L58.3633 62H55.5605L51.2812 49.4766L51.2129 49.4902L51.6094 57.5566V62H47.4395V44.0898Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5117 44.0898V58.8008H81.2227V62H69.3418V44.0898H73.5117Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/HTML.38723fcaa7e2b26b7726e3ab056f7649.svg";
export { ForwardRef as ReactComponent };